<template>
    <FormModal :model="model" :init="init" modal-id="shipping_item">
        <template>
            <div :key="key" class="d-flex">
                <b-badge
                    :variant="$store.getters['user/level2variant'](model.level)"
                    class="align-self-center mr-1"
                    >
                    {{
                    trans.labels[
                    'users.level.' + model.level
                    ]
                    }}
                </b-badge>
            </div>
        </template>
        <template v-slot:form="{ error: error }">
            <template v-if="model.is_edit_mode">
                <b-form-group
                    label-cols-sm="2"
                    label=""
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-checkbox
                        v-model="model.is_default"
                        :value="1"
                        :unchecked-value="0"
                        >
                        初期値として利用する
                    </b-form-checkbox>
                    <input-error :errors="error.is_default" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="保存名"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.name"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.name" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="商品名称（英語）"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.product"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.product" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="HSコード"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.hs_code"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.hs_code" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="通貨"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <SelectCurrencyId
                        v-model="model.currency"
                        />
                    <input-error :errors="error.currency" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="単価"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.price"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.price" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="原産国"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <SelectCountry
                        v-model="model.country"
                        />
                    <input-error :errors="error.type" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="数量"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.quantity"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.quantity" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="Net重量kg"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.weight_net"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.weight_net" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="Gross重量kg"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.weight_gross"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.weight_gross" />
                </b-form-group>
            </template>
            <template v-else>
            </template>
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import InputError from '@/components/InputError.vue'
import AddressContent from '@/components/AddressContent.vue'
import SelectCountry from '@/components/SelectCountry.vue'
import SelectCurrencyId from '@/components/SelectCurrencyId.vue'

export default {
    components: {
        FormModal,
        AddressContent,
        SelectCountry,
        InputError,
        SelectCurrencyId,
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'trans',
        ])
    },
    mounted() {},
    methods: {
    },
}
</script>

<style lang="scss" scoped></style>


